import Request from '../Request.utils'


class AirtableAPI {
  AirtableSyncAllMetafield = async () => {
    const res = await Request.call('/api/airtable/syncAllMetafield', 'POST', undefined, undefined, undefined, );
    return res;
  }
  AirtableSyncMetafieldToShopify = async () => {
    const res = await Request.call('/api/airtable/syncMetafieldToShopify', 'POST', undefined, undefined, undefined, );
    return res;
  }
  GetMappedFileURL = async () => {
    const res = await Request.call('/api/airtable/mappingDownloadFile/:baseId/:tableId/:airtableRecordId/:fileName', 'GET', undefined, undefined, undefined, );
    return res;
  }
  AirtableUploadImageToShopify = async () => {
    const res = await Request.call('/api/airtable/uploadImageToShopify', 'POST', undefined, undefined, undefined, );
    return res;
  }
  AirtableSyncProductDetailsToShopify = async () => {
    const res = await Request.call('/api/airtable/syncProductDetailsToShopify', 'POST', undefined, undefined, undefined, );
    return res;
  }
  SyncAllProductMediaFromShopify = async () => {
    const res = await Request.call('/api/airtable/syncAllProductMediaFromShopify', 'POST', undefined, undefined, undefined, );
    return res;
  }
}
export default new AirtableAPI()